import { Icon } from '@blueprintjs/core';
import { Text as AppText } from '@components';
import { TagNum } from '@components/TagNum/TagNum';
import { UnstyledButton } from '@mantine/core';
import { IProductSpec } from '@models/ProductSpec.model';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { setAttr } from '@utils/setAttr';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ProductSpec from './ProductSpec';

export interface ProductSpecGroupProps {
  name: string | null;
  specs: IProductSpec[];
  results: number | undefined;
  searchTerm: string;

  /* div props */
  className?: string | undefined;
}
type ProductSpecGroupType = React.FC<ProductSpecGroupProps>;

export function matchesGroup(searchTerm: string | undefined) {
  // Assume only groups with matches are shown.
  return Number(searchTerm?.length) > 0;
}

function ProductSpecGroup(props: ProductSpecGroupProps) {
  const { specs, name, results, searchTerm, ...rest } = props;
  const openByDefault = matchesGroup(searchTerm);
  const [open, setOpen] = useState(openByDefault);

  useEffect(() => {
    setOpen(openByDefault);
  }, [searchTerm]);

  return (
    <div {...rest}>
      <UnstyledButton
        className="GroupHead new-icon"
        onClick={() => setOpen(prev => !prev)}
      >
        <div className="GroupHeadTitle">
          <AppText text="p200" textColor="n700">
            {name}
          </AppText>
          <TagNum hidden={setAttr(!results)}>{results}</TagNum>
        </div>
        <Icon
          icon={open ? 'chevron-down' : 'chevron-right'}
          color={COLORS_FLAT.n600}
        />
      </UnstyledButton>
      <div hidden={setAttr(!open)}>
        {specs.map(spec => {
          return (
            <ProductSpec
              key={spec.id}
              hidden={!open}
              specName={spec.specName}
              specDetail={spec.specDetail}
              searchTerm={searchTerm}
            />
          );
        })}
      </div>
    </div>
  );
}
const StyledProductSpecGroup = styled(ProductSpecGroup)`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  .GroupHeadTitle {
    display: flex;
    column-gap: 8px;
    align-items: center;
  }
`;
export default React.memo(StyledProductSpecGroup) as ProductSpecGroupType;
